import template from '@components/expertise/discovery/discovery.module.scss'
import { StartProjectBlock } from '@components/shared/blocks/start-project-block';
import Link from 'next/link';
import { ILearnMoreSection } from '../../discovery.state';
import style from './index.module.scss'

interface LearMoreSectionProps {
    section: ILearnMoreSection;
}

const LearnMoreSectionComponent = ({ section }: LearMoreSectionProps) => {
    return (
        <StartProjectBlock title={section.title} buttonText={'Learn more'} link={'/blog/project-discovery-phase'} />
    )
}

export default LearnMoreSectionComponent;
